// extracted by mini-css-extract-plugin
module.exports = {"main":"Manifest-module__main--1kgVX","reveal":"Manifest-module__reveal--LpKX2","version":"Manifest-module__version--2pJB3"};